<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <!-- Recent Order Table -->
          <div class="card card-table-border-none" id="recent-orders">
            <div class="card-header justify-content-between">
              <h2>{{ $t("sidebar.myPurchases") }}</h2>
            </div>
            <div class="card-body table-responsive-xs table-responsive-sm card-white pt-0 pb-5">
              <table class="table card-table card-white table-striped" style="width:100%">
                <thead>
                  <tr>
                    <th class="d-md-table-cell text-center">
                      {{ $t("ecommerce.product.name") }}
                    </th>
                    <th class="d-md-table-cell d-none text-center">
                      {{ $t("ecommerce.orders") }}
                    </th>
                    <th class="d-md-table-cell d-none text-center">
                      {{ $t("ecommerce.product.totalPrice") }}
                    </th>
                    <th class="d-md-table-cell d-none text-center">
                      {{ $t("order.date") }}
                    </th>
                    <th class="d-md-table-cell d-none text-center">
                      {{ $t("checkout.orderInfo") }}
                    </th>
                    <th class="d-md-table-cell text-center">
                      {{ $t("main.action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.id">
                    <td class="d-md-table-cell text-center">
                      <a class="text-dark" href=""> {{ order.product.name }}</a>
                    </td>

                    <td class="d-md-table-cell d-none text-center">
                      {{ order.quantity }}
                    </td>

                    <td class="d-md-table-cell d-none text-center">
                      {{
                        order.price
                        | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td class="d-md-table-cell d-none text-center">
                      <span>{{
                        order.created_at | moment
                      }}</span>
                    </td>
                    <td class="d-md-table-cell d-none text-center">
                      <span>{{ order.order_information.delivery_street }}</span>
                    </td>
                    <td class="d-md-table-cell text-center">
                      <a :href="downloadUrl +
                        'order/' +
                        order.id +
                        '/print/' +
                        PURCHASES_INVOICES
                        " target="_blank" rel="noopener noreferrer">
                        {{ $t("action.downloadInvoice") }}
                      </a>
                      <router-link :to="{
                        name: 'showInvoice',
                        params: {
                          orderId: order.id,
                          type: PURCHASES_INVOICES,
                        },
                      }">
                        {{ $t("sentence.seeMore") }}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";
export default {
  mounted() {
    this.getUserOrders();
  },
  data() {
    return {
      orders: [],
      success: false,
      currentPage: 1,
      totalPages: 0,
      PURCHASES_INVOICES: "PURCHASES_INVOICES",
      downloadUrl: config.baseurl,
    };
  },
  methods: {
    getUserOrders() {
      var self=this;
      this.$store;
      this.$axios({
        url: "user/purchases",
        method: "GET",
      })
        .then((response) => {
          self.orders=response.data;
        })
        .catch(function (err) {
          console.log(err.response.data);
        });
    },
  },
  computed: {
    productsWithOrders() {
      return this.products.filter((i) => i.orders.length>0);
    },
  },
};
</script>
